import axiosInstance from "@/lib/axiosInstance";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosResponse, AxiosError } from "axios";
import { isAxiosError } from "axios";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
type PutRequestInterface = {
  path: string;
  param?: string | null;
  data?: object;
  errorTag: number | string;
  suppressErrorAlert?: boolean;
};

const putRequestFn = async ({ path, param, data, suppressErrorAlert }: PutRequestInterface) => {
  const PARAM = param ? `/${param}` : "";
  const config: CustomAxiosRequestConfig | undefined = suppressErrorAlert
    ? { suppressErrorAlert: true }
    : undefined;
  const res: AxiosResponse = await axiosInstance.put(`${path}${PARAM}`, data, config);
  return res.data?.data;
};

export const usePutRequestByParam = <TData = any>(props: {
  queryKey: string | readonly unknown[];
}) => {
  const queryClient = useQueryClient();
  const { queryKey } = props;

  const {
    mutate,
    isPending: isLoading,
    error,
    data: requestMuatationData,
  } = useMutation<TData, AxiosError, PutRequestInterface>({
    mutationFn: putRequestFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: Array.isArray(queryKey) ? queryKey : [queryKey] });
    },
    onError: (err) => {
      if (err != null && isAxiosError(err)) {
        console.error("PUT request error:", err);
      }
    },
  });

  return { mutate, isLoading, error, requestMuatationData };
};
